import React, { FC } from 'react'
import AllergyList from './AllergyList'
import AllergyDetail from './AllergyDetail'
import { AllergyIntoleranceBundle } from '../../../../types/FHIRTypes/Bundle'

type AllergiesProps = {
    allergyData?: AllergyIntoleranceBundle | undefined;
    allergyDetailId: string | undefined;
    page: string | undefined;
    isFetching: boolean;
    handleChangePage: (page: number) => void
    totalPages: number;
    currentPage: number;
}


const Allergies: FC<AllergiesProps> = ({ allergyData, allergyDetailId, page, isFetching, handleChangePage, totalPages, currentPage }) => {
    return (
        <div>
            {
                allergyDetailId && page === 'AllergyIntolerance' ? (
                    <AllergyDetail
                        allergyDetailId={allergyDetailId} />
                ) :
                    <AllergyList
                        allergyData={allergyData}
                        handleChangePage={handleChangePage}
                        totalPages={totalPages}
                        currentPage={currentPage}
                        isFetching={isFetching}
                    />
            }
        </div>
    )
}

export default Allergies